import { getEnvVariables } from '../services/optionsService.ts';

/**
 * Checks if the current environment is production.
 *
 * @returns {boolean} True if the environment is production, false otherwise.
 */
export const isProduction = (): boolean => {
  const env = getEnvVariables();
  return env.environment === 'prod';
};
